export interface ThemeConfig {
  defaultTheme: 'default' | 'violet' | 'custom';
  themes: Record<'default' | 'violet' | 'custom', ThemeDefinition>;
}

export interface ThemeDefinition {
  appLogoPath: string;
  loginLogoPath: string;
  allowedEmailDomains: string[];
  colors: ThemeColors;
}

export interface ThemeColors {
  primaryColor: string;
  primaryHoverColor: string;
  sidebarBg: string;
  sidebarLinkHoverBg: string;
  pageBg: string;
}

export const themeConfig: ThemeConfig = {
  defaultTheme: 'default',
  themes: {
    default: {
      appLogoPath: 'assets/images/Aquila-logo-2.svg',
      loginLogoPath: 'assets/images/mobily-white.svg',
      allowedEmailDomains: [''],
      colors: {
        // primaryColor: '#687257',
        // primaryHoverColor: '#858f76',
        primaryColor: '#00A7A9',
        primaryHoverColor: '#008284',
        sidebarBg: '#211E1F',
        sidebarLinkHoverBg: '#504e4f',
        pageBg: '#FFFFFF',
      },
    },
    violet: {
      appLogoPath: 'assets/images/mobily-white.svg',
      loginLogoPath: 'assets/images/mobily-white.svg',
      allowedEmailDomains: [''],
      colors: {
        primaryColor: '#ff6a39',
        primaryHoverColor: '#cc552d',
        sidebarBg: '#4f008c',
        sidebarLinkHoverBg: '#ffffff3d',
        pageBg: '#fff7f3',
      },
    },
    custom: {
      appLogoPath: 'assets/images/mobily-white.svg',
      loginLogoPath: 'assets/images/mobily-white.svg',
      allowedEmailDomains: [''],
      colors: {
        primaryColor: '#2d9ad6',
        primaryHoverColor: '#247cae',
        sidebarBg: '#124f75',
        sidebarLinkHoverBg: '#ffffff2e',
        pageBg: '#f9fafb',
      },
    },
  },
};
